<template>
  <div>
    <ViewSkinCheckImages @openDialog="view" ref="attachments" />

    <v-snackbar
      v-model="snackbar.showMsg"
      top
      :vertical="true"
      :color="snackbar.color"
    >
      {{ snackbar.msgContent }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          color="white"
          text
          v-bind="attrs"
          @click="snackbar.showMsg = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="getUnverifiedADL"
      item-key="_id"
      show-select
      class="elevation-1"
      :loading="$store.state.adl.loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <span class="text-subtitle-1"
              >Unverified Skin Check for the last 3 days</span
            ></v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <template>
            <v-btn color="primary" dark class="mb-2" @click="verify">
              Verify Selected
            </v-btn>
          </template>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="view(item)">
          mdi-eye
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
/*eslint-disable*/
import moment from "moment"
import { mapGetters, mapActions, mapMutations } from "vuex";
import ViewSkinCheckImages from "@/components/serviceplan/adl/ViewImages";

export default {
  components: {
    ViewSkinCheckImages,
  },
  props: {
    clientID: {
      type: String,
      default: "",
    },
    staff: {
      type: String,
      default: "",
    },
    userSignatureTz: {
      type: String,
    },
  },
  data() {
    return {
      selected: [],
      headers: [
        {
          text: "Date",
          align: "start",
          sortable: false,
          value: "Date",
        },
        { text: "Time", value: "Time" },
        { text: "Service", value: "Service" },
        { text: "Notes", value: "Notes" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      verifiedBy: "",
      snackbar: {
        showMsg: false,
        msgContent: "",
        color: "green accent-4",
      },
    };
  },

  created() {
    this.getClientUnverifiedADL(this.clientID);
  },

  computed: {
    ...mapGetters({
      getUnverifiedADL: "adl/getUnverifiedADL",
      getDefaultTz: "timezones/getDefaultTz",
    }),

  },

  methods: {
    ...mapActions({
      getClientUnverifiedADL: "adl/getClientUnverifiedADL",
      verifyADL: "adl/verifyADL",
      // viewImages: "adl/viewImages",
      viewAttachments: "adl/viewAttachments",
    }),

    ...mapMutations({
      setSnackbar: "adl/SET_SNACKBAR",
    }),

    async view(item) {
      const adlImage = await this.viewAdlImageUploads(item);
      this.$refs.attachments.openDialog(adlImage.data[0] || []);
    },

    async verify() {
      if (this.selected.length === 0) return alert("Nothing Selected");
      this.verifiedBy = this.staff + " - " + this.userSignatureTz;
      const selectedIds = this.selected.map((item) => item._id);
      try {
        const response = await this.verifyADL({
          data: { selectedIds, verifiedBy: this.verifiedBy },
          id: this.clientID,
        });

        if (response.success) {
          this.snackbar.showMsg = true;
          this.snackbar.msgContent = "Succesfully Verified Med/s";
          this.snackbar.color = "green accent-4";
        }
      } catch (error) {
        console.log(error);
      }
    },

    async viewAdlImageUploads(serv) {
      if(serv.ADLDocumentID){
        let adlImage = await this.viewAttachments(serv.ADLDocumentID);
         return adlImage;
      }
    },
  },
};
</script>
